/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_CrmInputs */

const cs_ebr_diff_crm = /** @type {(inputs: Ebr_Diff_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM`)
};

const en_ebr_diff_crm = /** @type {(inputs: Ebr_Diff_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM`)
};

/**
* | output |
* | --- |
* | "CRM" |
*
* @param {Ebr_Diff_CrmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_crm = /** @type {((inputs?: Ebr_Diff_CrmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_CrmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_crm(inputs)
	return cs_ebr_diff_crm(inputs)
});